/**
 * ReportsHarvestInspectionEntityName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    entityName?: ?string;
}

export class ReportsHarvestInspectionEntityName extends React.PureComponent<Props> {
    render() {
        const { entityName } = this.props;
        if (!entityName) return null;
        return entityName;
    }
}

const mapStateToProps = createStructuredSelector({
    entityName: makeSelectReportsHarvestInspectionValue('entityName')
});

export default connect(mapStateToProps)(ReportsHarvestInspectionEntityName);
